<script context="module">	
    //data shared accross each instance of this componenet
  let filter = {}; 
  let apiUrl = "";

  export function getFilter() {
	return filter;
  }

  export function updateFilter(f) {
	filter = {...filter, ...f}
    return filter
  }

  export function getApiUrl() {
	  return apiUrl;
  }

  export function setApiUrl(url) {
    apiUrl = url;
  }
  
</script>
  